import { useEffect, useState } from "react";

const navLinks = [
  { label: "今日瓜王", href: "#guanwang" },
  { label: "瓜田汇总", href: "#guatian" },
  { label: "本周大事", href: "#week" },
  { label: "热搜背后", href: "#shenbao" },
  { label: "瓜友讨论", href: "#discuss" },
  { label: "吃瓜问答", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full">
        <div className="h-[52px] bg-primary-500 hidden lg:flex items-center justify-center">
          <p className="font-label tracking-[0.25em] text-background-50 text-[13px]">
            MEIRI·CHIGUA · 全网热瓜一网打尽 · 理性吃瓜 · 轻松追更
          </p>
        </div>
        <div className="max-w-[1240px] mx-auto flex items-center justify-between px-4 md:px-6 h-16">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="每日吃瓜 首页">
            <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center text-background-50 font-label text-lg">
              瓜
            </span>
            <span className="font-heading font-bold text-xl md:text-2xl text-foreground-950 tracking-wide">
              每日吃瓜
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#discuss"
              className="ml-3 whitespace-nowrap px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              来聊一瓜
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>

        {open && (
          <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 animate-fade-up">
            <div className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="px-3 py-2.5 text-[15px] text-foreground-800 hover:bg-background-100 rounded-lg"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#discuss"
                onClick={() => setOpen(false)}
                className="mt-2 px-4 py-2.5 rounded-full bg-primary-500 text-background-50 text-center font-medium"
              >
                来聊一瓜
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}